import { useState, useEffect } from 'react';
import { Typography, Table, TableRow, TableCell } from './../../../tailwindcomponents';
import { ToolData } from '../../../types/tool';
import { EmployeeSearch, ProfileImg } from './../../../components';
import toolsApi from './../../../api/tools';
import { useSelector } from 'react-redux'
import { RootState } from '../../../reducer';

interface UserHistoryProps {
  setLoading: (loading: boolean) => void;
}

function UserHistory({ setLoading }: UserHistoryProps) {
  const [filtered_tools, setFilteredTools] = useState(Array<ToolData>())
  const [order_by_text, setOrderByText] = useState("Loaned out");
  const [ascending, setAscending] = useState(false);
  const [employee_id, setEmployeeId] = useState(0);
  const users = useSelector((state: RootState) => state.employees.all_employees);

  useEffect(() => {
    const returnInput = document.getElementById('textfield');
    returnInput?.focus();
  },);

  const generateTableBody = (row: ToolData, index: number) => {
    return (
      <TableRow>
        <TableCell>{index}</TableCell>
        <TableCell className="flex items-center gap-2">
          <ProfileImg imgKey={index} imgSize="xs" userName={users.find(s => s.Id === row.employee_id)?.userName.split('@')[0]} />
          <Typography align="left" text={row.employee_name} display="inline"></Typography>
        </TableCell>
        <TableCell>{row.bay}</TableCell>
        <TableCell>{row.area}</TableCell>
        <TableCell>{row.out_date_text}</TableCell>
        <TableCell>{row.in_date_text}</TableCell>
        <TableCell>{row.description}</TableCell>
        <TableCell>{row.serial}</TableCell>
      </TableRow>
    )
  }

  const refresh = (mxi_inv_no_id: number, employee_id: number, order_by_text: string, ascending: boolean) => {
    setLoading(true);
    toolsApi.getSingleToolsHistory(mxi_inv_no_id, employee_id, order_by_text, ascending).then(res => {
      setFilteredTools(res);
    }).finally(() => setLoading(false));
  }

  const OnOrderByTitles = (given_order_by_text: string) => {
    let temp_ascending = true;
    if (order_by_text === given_order_by_text) { temp_ascending = ascending === false ? true : false; }
    setAscending(temp_ascending);
    setOrderByText(given_order_by_text);
    refresh(0, employee_id, given_order_by_text, temp_ascending);
  }

  const onSelectedEmployeeRow = (employee_id: number) => {
    setEmployeeId(employee_id);
    refresh(0, employee_id, order_by_text, ascending);
  };

  return (
    <div className="w-full">
      <Typography text={"Search for users history"} align="center" variant="h2" />
      <Typography text={`Total available (${filtered_tools.length})`} align="center" variant={"body1"} />
      <div className="flex flex-wrap w-1/3 ml-[35%]">
        <EmployeeSearch place_holder={"Write employees name"} onSelectedEmployee={(employee_id: number) => onSelectedEmployeeRow(employee_id)} />
      </div>
      <Table
        headers={["Name", "Bay", "Area", "Loaned out", "Returned", "Description", "Serial"]}
        rows={filtered_tools}
        generateBody={(row: any, index: number) => generateTableBody(row, index)}
        defaultRowsPerPage={100}
        OnOrderByTitles={(order_by_text: string) => OnOrderByTitles(order_by_text)}
      />
    </div>
  );
};
export default UserHistory;